/* @flow weak */
import cx from 'classnames';
import React from 'react';
import Legend from 'components/Legend.jsx';

const WalletTabSection = ({ className, title = '', children }) =>
  <div className={cx('WalletTabSection', className)}>
    <Legend text={title} />
    {children}
  </div>;

WalletTabSection.propTypes = {
  title: React.PropTypes.string,
  children: React.PropTypes.node.isRequired,
};

export default WalletTabSection;



// WEBPACK FOOTER //
// ./src/payments/components/WalletTabSection.jsx